<template>
  <el-container class="home-container">
    <!--头部布局-->
    <el-header style="height: 70px;">
      <div style="height: 80px;padding-left: 10px;">
        <img src="../assets/logo.png" @click="getTopByList('/welcome')" style="cursor:pointer;"/>
        <el-menu
            class="el-menu-demo"
            mode="horizontal"
            background-color="#2f70b9"
            text-color="#fff"
            active-text-color="#67C23A"  >

            <el-menu-item index="1" @click="getTopByList('/bjgwyf')">补充工伤保险办理</el-menu-item>
            <el-menu-item index="5" @click="getTopByList('/bcylbx_year')">补充医疗业务办理</el-menu-item>
            <el-menu-item index="2" @click="getTopByList('/sljl')">受理记录</el-menu-item>
<!--            <el-menu-item index="3" @click="getTopByList('/insuranceClaims')">保险理赔流程</el-menu-item>-->
            <el-menu-item index="4" @click="getTopByList('/fpgl')">发票管理</el-menu-item>
           <el-menu-item index="6" @click="getTopByList('/xslpsqlc')">线上理赔申请流程</el-menu-item>
            <!-- <el-menu-item index="6" @click="getTopByList(6)">系统管理</el-menu-item> -->

        </el-menu>
      </div>

      <el-dropdown @command="handleCommand">

        <span class="el-dropdown-link el-icon-user-solid" style="color: #fff;">
            {{user.aab002}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">单位信息维护</el-dropdown-item>
            <el-dropdown-item command="b">修改密码</el-dropdown-item>
            <el-dropdown-item command="c">安全退出</el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>
      <!-- <el-button type="info" @click="logout">安全退出</el-button> -->
    </el-header>
    <el-container>
        <el-drawer title="修改密码" :visible.sync="drawer" >
            <div class="register right">
                <!-- <h3 class="login__title" style="text-align: left;">修改密码</h3> -->
                <!--忘记密码-->
                <el-form ref="changePasswordFormRef" :model="changePasswordForm" :rules="changePasswordRules" class="login_form">
                    <el-form-item label="单位编码：">
                        <span style="font-size: 16px;">{{user.aab001}}</span>
                    </el-form-item>
                    <el-form-item prop="password" v-show="changePassword1" class="login_input">
                        <el-input v-model="changePasswordForm.password" prefix-icon="iconfont icondenglumima
                        " placeholder="请输入用户原密码" type="password"><i slot="suffix" class="el-icon-view" @click="changePasswordShow1" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
                    </el-form-item>
                    <el-form-item prop="password" v-show="changePassword2" class="login_input">
                        <el-input v-model="changePasswordForm.password" prefix-icon="iconfont icondenglumima
                        " placeholder="请输入用户原密码"><i slot="suffix" class="el-icon-key" @click="changePasswordShow1" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
                    </el-form-item>
                    <el-form-item prop="changepassword" v-show="changePassword3" class="login_input">
                        <el-input v-model="changePasswordForm.changepassword" prefix-icon="iconfont icondenglumima
                        " placeholder="请输入修改用户密码" type="password"><i slot="suffix" class="el-icon-view" @click="changePasswordShow2" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
                    </el-form-item>
                    <el-form-item prop="changepassword" v-show="changePassword4" class="login_input">
                        <el-input v-model="changePasswordForm.changepassword" prefix-icon="iconfont icondenglumima
                        " placeholder="请输入修改用户密码"><i slot="suffix" class="el-icon-key" @click="changePasswordShow2" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
                    </el-form-item>
                    <el-form-item prop="newpassword" v-show="changePassword5" class="login_input">
                        <el-input v-model="changePasswordForm.newpassword" prefix-icon="iconfont iconmima" placeholder="请输入修改用户密码" type="password"><i slot="suffix" class="el-icon-view" @click="changePasswordShow3" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
                    </el-form-item>
                    <el-form-item prop="newpassword" v-show="changePassword6" class="login_input">
                        <el-input v-model="changePasswordForm.newpassword" prefix-icon="iconfont iconmima" placeholder="请输入修改用户密码"><i slot="suffix" class="el-icon-key" @click="changePasswordShow3" style="font-size: 20px;height: 50px;padding-top: 15px;"></i></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="changePassword" class="login_button">确定</el-button>
                        <!-- <el-button type="info" @click="resetLoginForm">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-drawer>
        <el-dialog title="单位信息维护" :visible.sync="dialogFormVisible">
            <el-form :model="updateuser" ref="updateuser" :rules="updateuserRules" label-width="110px" class="demo-ruleForm" style="text-align: center;">
                <el-row :gutter="20">
                    <el-col :span="18" :offset="2" >
                        <el-form-item label="单位编号" prop="aab001">
                            <el-col :span="24">
                                <el-input v-model="updateuser.aab001"  :disabled="true" placeholder="请输入单位编号"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="单位名称" prop="aab002">
                            <el-col :span="24">
                                <el-input v-model="updateuser.aab002"  placeholder="请输入单位名称"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2" >
                        <el-form-item label="单位地址" prop="address">
                            <el-col :span="24">
                                <el-input v-model="updateuser.address" placeholder="请输入单位地址"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="联系人姓名" prop="lxrname">
                            <el-col :span="24">
                                <el-input v-model="updateuser.lxrname" placeholder="请输入联系人姓名"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="联系人电话" prop="lxrphone">
                            <el-col :span="24">
                                <el-input v-model="updateuser.lxrphone" placeholder="请输入联系人电话"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="邮箱" prop="lxremail">
                            <el-col :span="24">
                                <el-input v-model="updateuser.lxremail" placeholder="请输入邮箱"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
<!--                <el-row :gutter="20"  style="padding-top: 8px;">-->
<!--                    <el-col :span="18" :offset="2">-->
<!--                        <el-form-item label="行业类型" >-->
<!--                            <el-col :span="6" style="text-align: left;">-->
<!--                                <el-button :type="buttontype" @click="innerVisible = true">{{buttonstate}}</el-button>-->
<!--                            </el-col>-->
<!--                            <el-col :span="18" style="text-align: left;">-->
<!--                                <span>{{updateuser.column1}}</span>-->
<!--                            </el-col>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
<!--                </el-row>-->
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="统一信用代码" prop="snumber">
                            <el-col :span="24">
                                <el-input v-model="updateuser.snumber" placeholder="请输入统一信用代码"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="法人代表" prop="headuser">
                            <el-col :span="24">
                                <el-input v-model="updateuser.headuser" placeholder="请输入法人代表"></el-input>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20"  style="padding-top: 8px;">
                    <el-col :span="18" :offset="2">
                        <el-form-item label="注册所在区" prop="dsfj">
                            <el-col :span="24" style="text-align: left;">
                                <el-select v-model="updateuser.dsfj" placeholder="请选择">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>

                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="submitForm('updateuser')">确定修改</el-button>
                <!-- <el-button @click="resetForm('updateuser')">重置</el-button> -->
            </div>
            <el-dialog width="50%" title="请选择行业类型" :visible.sync="innerVisible" append-to-body>
                <el-table ref="multipleTable" :data="tableData" :show-overflow-tooltip='true' tooltip-effect="dark" style="width: 100%">
                    <el-table-column width="60">
                        <template slot-scope="scope">
                            <el-radio :label="scope.$index" v-model="usertype" @change.native="getTemplateRow(scope.$index,scope.row)" >&nbsp;</el-radio>
                        </template>
</el-table-column>
<el-table-column prop="hylb" width="80" label="行业类别">
</el-table-column>
<el-table-column prop="fy" label="缴费标准" width="140">
</el-table-column>
<el-table-column prop="ejfl" label="二级分类" width="80">
</el-table-column>
<el-table-column prop="hymc" label="行业名称" show-overflow-tooltip>
</el-table-column>
<el-table-column prop="baserate" label="基准费率(%)" width="90">
</el-table-column>

</el-table>
<div style="padding-top: 10px;text-align: center;">
    <el-button type="primary" @click="gethylb">确定</el-button>
</div>

</el-dialog>

</el-dialog>
<!--侧边布局-->
<el-aside :width="isCollapse ?'64px':'200px'" v-if="menushow">
  <el-menu class="el-menu-vertical-demo" :default-active="activePath" unique-opened :collapse="isCollapse"
           :collapse-transition="false" :router="true">

    <!--        <el-submenu index="1" v-show="show1 =='1'">-->
    <!--            <template slot="title">-->
    <!--            <i class="iconfont iconyue"></i>-->
    <!--            <span>月缴</span>-->
    <!--        </template>-->
    <!--            <el-menu-item index="/nochangeRenewal" @click="saveNavState('/nochangeRenewal')">人员无变化申报</el-menu-item>-->
    <!--            <el-menu-item index="/changeRenewal" @click="saveNavState('/changeRenewal')">人员有变化申报</el-menu-item>-->
    <!--            <el-menu-item index="/bjgwyf" @click="saveNavState('/bjgwyf')">补缴过往月份</el-menu-item>-->
    <!--            <el-menu-item index="/dwmcbgbq_month" @click="saveNavState('/dwmcbgbq_month')">单位名称变更保全</el-menu-item>-->

    <!--        </el-submenu>-->
    <!--        <el-submenu index="3" v-show="show1 == '1'">-->
    <!--            <template slot="title">-->
    <!--            <i class="iconfont iconnian"></i>-->
    <!--            <span>年缴</span>-->
    <!--        </template>-->
    <!--            <el-menu-item index="/yearpay" @click="saveNavState('/yearpay')">年缴新参保及到期续保</el-menu-item>-->
    <!--            <el-menu-item index="/dwmcbgbq_year" @click="saveNavState('/dwmcbgbq_year')">单位名称变更保全</el-menu-item>-->

    <!--        </el-submenu>-->
    <!--        <el-menu-item index="jdjf" @click="saveNavState('/jdjf')" v-show="show1 == '1'">-->
    <!--            <i class="iconfont iconjidu"></i>-->
    <!--            <span slot="title">季缴</span>-->

    <!--        </el-menu-item>-->
    <!--         <el-menu-item index="bnjf" @click="saveNavState('/bnjf')" v-show="show1 == '1'">-->
    <!--            <i class="iconfont iconjidu"></i>-->
    <!--            <span slot="title">半年缴</span>-->

    <!--        </el-menu-item>-->
    <!--      <el-menu-item index="/bjgwyf" @click="saveNavState('/bjgwyf')" v-show="show1 == '1'">-->
    <!--        <i class="iconfont icontubiao22"></i>-->
    <!--        <span slot="title">补充工伤保险办理</span>-->
    <!--      </el-menu-item>-->

    <el-submenu index="1" v-show="show1 == '1'">
      <template slot="title">
        <i class="iconfont iconjilu1"></i>
        <span>补充工伤保险办理</span>
      </template>
      <el-menu-item index="/bjgwyf" @click="saveNavState('/bjgwyf')">补充工伤保险办理</el-menu-item>
      <el-menu-item index="/bjgwyfbj" @click="saveNavState('/bjgwyfbj')">补充工伤保险补缴办理</el-menu-item>
    </el-submenu>

    <el-menu-item index="/bcylbx_year" @click="saveNavState('/bcylbx_year')" v-show="show1 == '2'">
      <i class="iconfont icontubiao22"></i>
      <span slot="title">补充医疗保险年缴办理</span>
    </el-menu-item>

    <el-submenu index="5" v-show="show1 == '3'">
      <template slot="title">
        <i class="iconfont iconjilu1"></i>
        <span>业务查询</span>
      </template>
      <el-menu-item index="/sljl" @click="saveNavState('/sljl')">受理记录</el-menu-item>
      <el-menu-item index="/bcylsljl" @click="saveNavState('/bcylsljl')">补充医疗受理记录</el-menu-item>
      <el-menu-item index="/bcgssljl" @click="saveNavState('/bcgssljl')">补充工伤受理记录</el-menu-item>
      <el-menu-item index="/bcgsbjsljl" @click="saveNavState('/bcgsbjsljl')">补充工伤补缴受理记录</el-menu-item>
    </el-submenu>

<!--    <el-menu-item class="iconfont icon_baoxianlipei1" index="/insuranceClaims"-->
<!--                  @click="saveNavState('/xslpsqlc')" v-show="show1 == '6'">-->
<!--      线上理赔申请流程-->
<!--    </el-menu-item>-->
    <el-menu-item index="/xslpsqlc" v-show="show1 == '6'">
      <i class="iconfont icon_baoxianlipei1"></i>
      <span slot="title">线上理赔申请流程</span>
    </el-menu-item>
    <el-menu-item index="/fpgl" v-show="show1 == '5'">
      <i class="iconfont iconfapiaoguanli1"></i>
      <span slot="title">发票打印</span>
    </el-menu-item>
    <!-- <el-menu-item index="8">
    <i class="el-icon-circle-close"></i>
    <span slot="title" @click="logout">退出</span>
</el-menu-item> -->
  </el-menu>

</el-aside>
<!--主体布局-->
<el-main>
    <!--路由占位符-->
    <router-view></router-view>
</el-main>
</el-container>
</el-container>

</template>
<script>
    export default {
        inject: ['reload'],
        data() {
            return {
                // 左侧菜单
                menuList: [],
                iconsObject: {
                    '100': 'iconfont iconguanliyuan',
                    '200': 'iconfont iconsport',
                    '101': 'iconfont icondenglu',
                    '102': 'iconfont iconmima',
                    '103': 'iconfont iconsport',
                    '104': 'iconfont iconshangpin',
                    '201': 'iconfont iconshu',
                    '202': 'iconfont iconkaluli',
                    '203': 'iconfont iconshiwu',
                    '204': 'iconfont icondenglu',
                },
                pathshow: {
                    '/bcgsbxbl': '1',
                    '/changeRenewal': '1',
                    '/nochangeRenewal': '1',
                    '/bjgwyf': '1',
                    '/bjgwyfbj': '1',
                    '/dwmcbgbq_month': '1',
                    '/yearpay': '1',
                    '/dwmcbgbq_year': '1',
                    '/jdjf': '1',
                    '/bnjf': '1',
                    '/bcylbx_year': '2',
                    '/sljl': '3',
                    '/bcylsljl': '3',
                    '/bcgssljl': '3',
                    '/bcgsbjsljl': '3',
                    '/insuranceClaims': '4',
                    '/fpgl': '5',
                    '/xslpsqlc': '6',
                },

                // show1: window.sessionStorage.getItem('activePath') == null ? "/changeRenewal" : window.sessionStorage.getItem('activePath'),
                show1: '',
                menushow: false,
                isCollapse: false,
                drawer: false,
                // 被激活的连接
                activePath: '',
                changePasswordForm: {

                    password: "",
                    changepassword: "",
                    newpassword: "",

                },
                changePassword1: true,
                changePassword2: false,
                changePassword3: true,
                changePassword4: false,
                changePassword5: true,
                changePassword6: false,

                dialogFormVisible: false,
                innerVisible: false,

                //单位信息修改时选择行业类型
                buttontype: 'primary',
                buttonstate: '请选择',


                updateuser: {
                    aab001: '',
                    aab002: '',
                    address: '',
                    lxrname: '',
                    lxrphone: '',
                    lxremail: '',
                    snumber: '',
                    headuser: '',
                    dsfj: '',
                    usertype: '',
                    column1: '',
                    rqtime: '',
                    raddress: ''


                },
                updateuserRules: {
                    aab001: [{
                        required: true,
                        message: '请输入单位编号',
                        trigger: 'blur'
                    }, {
                        min: 20,
                        max: 20,
                        message: '长度 20 个字符！',
                        trigger: 'blur'
                    }],
                    aab002: [{
                        required: true,
                        message: '请单位名称',
                        trigger: 'blur'
                    }],
                    address: [{
                        required: true,
                        message: '请单位地址',
                        trigger: 'blur'
                    }],
                    lxrname: [{
                        required: true,
                        message: '请联系人姓名',
                        trigger: 'blur'
                    }],
                    lxrphone: [{
                        required: true,
                        message: '请输入联系人电话',
                        trigger: 'blur'
                    }, {
                        min: 6,
                        max: 13,
                        message: '长度在 6 到 13 个字符',
                        trigger: 'blur'
                    }],
                    lxremail: [{
                        required: true,
                        message: '请输入邮箱地址',
                        trigger: 'blur'
                    }, {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur', 'change']
                    }],
                    column1: [{
                        required: true,
                        message: '请选择行业类型',
                        trigger: 'blur',
                    }],
                    snumber: [{
                        required: true,
                        message: '请输入统一信用代码',
                        trigger: 'blur'
                    }],
                    headuser: [{
                        required: true,
                        message: '请输入法人代表',
                        trigger: 'blur'
                    }],
                    dsfj: [{

                        required: true,
                        message: '请选择注册所在区',
                        trigger: 'change'
                    }],

                },

          tableData: [{
                    hylb: '一类甲',
                    fy: '6元',
                    ejfl: '一类甲',
                    hymc: '软件和信息技术服务业，货币金融服务，资本市场服务， 保险业， 其他金融业， 科技推广和应用服务业， 社会工作， 广播、 电视、 电影和影视录音制作业， 中国共产党机关， 国家机构， 人民政协、 民主党派， 社会保障， 群众团体、 社会团体和其他成员组织， 基层群众自治组织， 国际组织。 ',
                    baserate: '0.3'
                }, {
                    hylb: '一类乙',
                    fy: '12元',
                    ejfl: '一类乙',
                    hymc: '批发业，零售业，仓储业，邮政业，住宿业，餐饮业，电信、广播电视和卫星传输服务，互联网和相关服务，房地产业，租赁业，商务服务业，研究和试验发展，专业技术服务业，居民服务业，其他服务业，教育，卫生，新闻和出版业，文化艺术业。',
                    baserate: '0.6'
                }, {
                    hylb: '二类甲',
                    fy: '9元',
                    ejfl: '二类甲',
                    hymc: '农副食品加工业，食品制造业，酒、饮料和精制茶制造业，烟草制品业，纺织业，木材加工和木、竹、藤、棕、草制品业，文教、工美、体育和娱乐用品制造业，计算机、通信和其他电子设备制造业，仪农副食品加工业，食品制造业，酒、饮料和精制茶制造业，烟草制品业，纺织业，木材加工和木、竹、藤、棕、草制品业，文教、工美、体育和娱乐用品制造业，计算机、通信和其他电子设备制造业，仪器仪表制造业，其他制造业，水的生产和供应业，机动车、电子产品和日用产品修理业，水利管理业，生态保护和环境治理业，公共设施管理业，娱乐业。',
                    baserate: '1.05'
                }, {
                    hylb: '二类乙',
                    fy: '9元',
                    ejfl: '二类乙',
                    hymc: '农业，畜牧业，农、林、牧、渔服务业，纺织服装、服饰业，皮革、毛皮、羽毛及其制品和制鞋业，印刷和记录媒介复制业，医药制造业，化学纤维制造业，橡胶和塑料制品业，金属制品业，通用设备制造业，专用设备制造业，汽车制造业，铁路、船舶、航空航天和其他运输设备制造业，电气机械和器材制造业，废弃资源综合利用业，金属制品、机械和设备修理业，电力、热力生产和供应业，燃气生产和供应业，铁路运输业，航空运输业，管道运输业，体育。',
                    baserate: '1.35'
                }, {
                    hylb: '二类丙',
                    fy: '9元',
                    ejfl: '二类丙',
                    hymc: '林业，开采辅助活动，家具制造业，造纸和纸制品业，建筑安装业，建筑装饰和其他建筑业，道路运输业，水上运输业，装卸搬运和运输代理业。',
                    baserate: '1.65',
                }, {
                    hylb: '三类甲',
                    fy: '11元',
                    ejfl: '三类甲',
                    hymc: '渔业，化学原料和化学制品制造业，非金属矿物制品业，黑色金属冶炼和压延加工业，有色金属冶炼和压延加工业，房屋建筑业，土木工程建筑业。',
                    baserate: '1.95'
                }, {
                    hylb: '三类乙',
                    fy: '11元',
                    ejfl: '三类乙',
                    hymc: '石油和天然气开采业，其他采矿业，石油加工、炼焦和核燃料加工业。',
                    baserate: '2.4'
                }, {
                    hylb: '三类丙',
                    fy: '11元',
                    ejfl: '三类丙',
                    hymc: '煤炭开采和洗选业，黑色金属矿采选业，有色金矿采选业，非金属矿采选业。',
                    baserate: '2.85'

                }],
                //选择行业类别
                usertype: '',
                //选择注册所在区
                 options: [{
                    value:  '01',
                    label:  '盘锦市本级'
                },  {
                    value:  '02',
                    label:  '兴隆台'
                },  {
                    value:  '03',
                    label:  '辽东湾'
                },  {
                    value:  '04',
                    label:  '双台子'
                },  {
                    value:  '05',
                    label:  '大洼'
                },  {
                    value:  '06',
                    label:  '盘山县'
                },  {
                    value:  '07',
                    label:  '油田'
                },  {
                    value:  '08',
                    label:  '事业单位'
                }],

                multipleSelection: [],
                changePasswordRules: {

                    password: [{
                        required: true,
                        message: "请输入原密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],
                    changepassword: [{
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],
                    newpassword: [{
                        required: true,
                        message: "请再次输入密码",
                        trigger: "blur",
                    }, {
                        min: 6,
                        max: 8,
                        message: "密码为 6~8 位",
                        trigger: "blur",
                    }, ],

                },
            }
        },
        // 类似onload
        created() {

            this.activePath = window.sessionStorage.getItem('activePath'); // 取出session里的访问路径
            this.user = JSON.parse(window.sessionStorage.getItem("user"));
            console.log(this.user)
            window.addEventListener('setItem', () => {

                this.user = JSON.parse(window.sessionStorage.getItem("user"));

            })
            this.updateuser = this.user;
            if (this.updateuser.usertype != null) {
                this.usertype = (this.updateuser.usertype.substring(1) - 0) - 1;
                this.buttontype = 'success';
                this.buttonstate = '已选择';
            }


        },
        //坚定url访问路径动态获取对应菜单栏并给予高亮
        watch: {
            $route: {
                handler(route) {
                    this.activePath = route.path;
                    if (this.activePath == '/welcome') {
                        this.menushow = false;
                        // this.show1 = "/changeRenewal";
                    } else {
                        this.menushow = true;
                        this.show1 = this.pathshow[this.activePath];
                        this.saveNavState(this.activePath);
                    }


                },
                immediate: true
            }
        },
        methods: {
            logout() {
                window.sessionStorage.clear();
                this.$router.push("/login");
            },
            handleCommand(command) {

                if (command == 'a') {

                    this.updateuser = JSON.parse(window.sessionStorage.getItem("user"));
                    this.dialogFormVisible = true;


                }
                if (command == 'b') {
                    this.drawer = true;

                }
                if (command == 'c') {

                    window.sessionStorage.clear();
                    this.$router.push("/login");
                }


            },
            // 保存二级菜单的路径
            saveNavState(activePath) {
                window.sessionStorage.setItem('activePath', activePath); // 存放点击的二级菜单
                this.activePath = activePath; // 给点击的菜单添加高亮
            },

            //更改业务改变菜单
            // changeButton() {
            //     this.$router.push("/changeRenewal");
            // },
            // 顶栏切换获取所有的导航菜单
            getTopByList(numids) {
                this.show1 = this.pathshow[numids];
              if (numids != window.sessionStorage.getItem('activePath')) {
                    this.saveNavState(numids);
                    this.$router.push(numids);
                }

            },
            //忘记密码时显示隐藏密码
            changePasswordShow1() {
                this.changePassword1 = !this.changePassword1;
                this.changePassword2 = !this.changePassword2;

            },
            //忘记密码时显示隐藏密码
            changePasswordShow2() {

                this.changePassword3 = !this.changePassword3;
                this.changePassword4 = !this.changePassword4;
            },
            //忘记密码时显示隐藏密码
            changePasswordShow3() {

                this.changePassword5 = !this.changePassword5;
                this.changePassword6 = !this.changePassword6;
            },
            //修改改密码
            changePassword() {
                this.$refs.changePasswordFormRef.validate(async valid => {
                    console.log(valid);
                    if (!valid) return;
                    this.user = JSON.parse(window.sessionStorage.getItem("user"));
                    if (this.changePasswordForm.password != this.user.password) {
                        return this.$message.error("密码不一致，请更改输入原密码！！！");
                    }

                    if (this.changePasswordForm.changepassword != this.changePasswordForm.newpassword) {
                        return this.$message.error("密码不一致，请更改输入新密码！！！");
                    }
                    // 发起请求
                    const {
                        dataType: json,
                        data: res
                    } = await this.$http.get("changePassword?password=" + this.changePasswordForm.changepassword + "&aab001=" + this.user.aab001);

                    if (res.result != "success") {

                        return this.$message.error("找回密码失败！！！");
                    }

                    this.$message.success("修改密码成功！！！");
                    // window.sessionStorage.setItem("user", JSON.stringify(res.user)); // session 放置
                    this.resetSetItem('user', JSON.stringify(res.user));
                    this.$refs.changePasswordFormRef.resetFields(); // 重置表单项
                    this.drawer = false;
                    // this.$router.go(0);
                    //隐藏
                    // this.addDialogVisible = false;
                    // this.getUserList();
                })
            },
            //获取选中数据
            getTemplateRow(index, row) {
                this.updateuser.usertype = '0' + (index + 1);
                this.updateuser.column1 = row.ejfl + '  ' + row.fy;
                this.buttontype = 'success';
                this.buttonstate = '已选择';

            },
            //确定选择行业类别
            gethylb() {

                this.innerVisible = false;
            },
            //提交单位信息维护
            async submitForm(formName) {
                // if (this.updateuser.column1 === undefined) {
                //     this.$message({
                //         showClose: true,
                //         message: "请选择行业类型",
                //         type: 'warning',
                //         customClass: 'mzindex'
                //     });
                //     return;
                // }
                this.$refs[formName].validate(async valid => {
                    console.log(valid);
                    if (!valid) return;
                    // 发起请求
                    let moment = require('moment');
                    this.updateuser.rqtime = moment().format("YYYY-MM-DD HH:mm:ss");
                    this.updateuser.raddress = this.updateuser.dsfj;
                    const {
                        data: res
                    } = await this.$http.post("updatePiccuser", this.updateuser);
                    if (res.result != "success") {
                        return this.$message.error("操作失败！！！");
                    }
                    this.$message.success("单位信息维护修改成功！！！");

                    // window.sessionStorage.setItem("user", JSON.stringify(res.user)); // session 放置
                    this.resetSetItem('user', JSON.stringify(res.user));
                    //隐藏
                    this.dialogFormVisible = false;
                })
            },
            //重置单位信息维护表单
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.updateuser = {};

            },


        }
    };
</script>
<style lang="less" scoped>
    .el-header {
        background-color: #2f70b9;
        display: flex;
        justify-content: space-between; // 左右贴边
        padding-left: 0%; // 左边界
        align-items: center; // 水平
        color: #fff;
        font-size: 20px;
        >div {
            //左侧div加布局
            display: flex;
            align-items: center;
            span {
                margin-left: 15px;
                color: #000;
            }
        }
    }

    .el-aside {
        background-color: #ffffff;
        .el-menu {
            border-right: none; // 对其右边框
        }
    }

    .el-main {
        background-color: #eaedf1;
    }

    .home-container {
        height: 100%;
    }

    .logo_img {
        width: 100%;
        height: 100%;
    }

    .iconfont {
        margin-right: 10px;
    }

    .toggle-button {
        background-color: #4A5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer; // 显示鼠标指针为：小手
    }

    .el-menu--horizontal>.el-menu-item {
        float: left;
        height: 70px;
        line-height: 70px;
        margin: 0;
        border-bottom: 2px solid transparent;
        border-bottom-color: transparent;
        color: #909399;
    }

    .login_form {
        width: 300px;
        margin: auto;
    }

    .login_button {
        width: 300px;
        margin-top: 15px;
    }

    /deep/.el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
        width: 92px;
    }

    /deep/.el-radio__label {
        font-size: 14px;
        padding-left: 10px;
        display: none;
    }

    .el-form-item {
        margin-bottom: 12px;
    }

    .login_input {
        padding-top: 10px;
    }
</style>
<style>
    .el-tooltip__popper {
        max-width: 50%;
    }

    .el-tooltip__popper,
    .el-tooltip__popper.is-dark {
        background: rgb(48, 65, 86) !important;
        color: #fff !important;
        line-height: 24px;
    }
</style>
